import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "order-tracker-mixin",
  computed: {
    ...mapGetters('locationStore', ['getTrackedOrder']),
    ...mapState('userStore', ['guestData']),
  },
  beforeUpdate() {
    if (this.isAuthenticated || this.guestData) {
      this.fetchLastLiveOrder();
    }
  },
  methods: {
    ...mapActions('locationStore', ["saveTrackedOrder"]),
    fetchLastLiveOrder() {
      let params = {
        user_id: this.user.id || this.guestData.id,
        user_type: this.isAuthenticated ? "User" : "Guest",
      };

      this.fetchTrackingOrder(params)
        .then((response) => {
          if (response.data && response.data.id) {
            let trackingObj = this.getTrackedOrder.find(x => x.id == response.data.id)

            if (!trackingObj) {
              trackingObj = { id: response.data.id, skip_review: false }
              this.saveTrackedOrder(trackingObj)
            }
          }
        })
        .catch(() => { });
    },
  },
};
